<template src="./selfCheckoutUserQR.html"></template>

<script>
// import axios from 'axios';
// const Config = require('~/config/default.env').default;

export default {
  name: 'home',
  components: {},
  data() {
    return {
      quotes: null,
    };
  },
  // created(){
  //   axios
  //   .get('https://soco-loyalty-feature-api.sociolabs.io/beauty-quotes?limit=1&sort=-created_at')
  //   .then(res => {
  //   const data = res.data.data;
  // //   console.log(data);
  //   this.quotes = data;
  // });

  // },
  computed: {
    user() {
      return this.$store.state.QRcode.user;
    },
    isLogin() {
      // console.log(this.user)
      return this.$SO.size(this.user);
    },
    // eslint-disable-next-line vue/return-in-computed-property
    style() {
      if (this.$store.state.checkinStation.background) {
        return `background-image:url(${this.$store.state.checkinStation.background});`;
      }
    },
  },
  created() {
    if (!this.isLogin) {
      this.$router.push('/self-checkout/home');
    }
    setTimeout(
      function () {
        this.$router.push('/self-checkout/home');
      }.bind(this),
      10000
    );
  },
  methods: {
    replaceByDefault(e) {
      e.target.src = '/static/img/avatar-soco.png';
    },
    getStoreName() {
      let name = '';
      if (Cookies.get('store_detail') && Cookies.get('store_detail') != undefined) {
        try {
          const json_data = JSON.parse(Cookies.get('store_detail'));
          name = json_data.name;
        } catch (err) {}
      }
      // if (Cookies.get('store_location_id') && Cookies.get('store_location_id') != undefined) {
      //     for (var i in Config.store_lists) {
      //         if (Config.store_lists[i].id == Number(Cookies.get('store_location_id'))) {
      //             name = Config.store_lists[i].value
      //         }
      //     }
      // }
      return name;
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'selfCheckoutUserQR';
</style>
